var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"channel-videos__section-list"},[_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('ChannelVideos',{attrs:{"videos":_vm.videos}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }